import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AppAlertProvider } from "./components/AppAlertDialog";
import { I18nProvider } from "./i18n";
import "./styles.css";
import "./compact-density.css";
import "./landing-experience.css";
import "./legal/legal-pages.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });

const root = document.getElementById("root");
if (!root) throw new Error("Root element was not found.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppAlertProvider>
        <I18nProvider><BrowserRouter>
          <App />
        </BrowserRouter></I18nProvider>
      </AppAlertProvider>
    </QueryClientProvider>
  </StrictMode>,
);
